module.exports = __webpack_public_path__ + "img/slide-3.13a61285.png";